import styled from "styled-components";

export const HeaderContainer = styled.header`
  background-color: ${props => props.theme.colors.header};
  color: ${props => props.theme.colors.onColor};
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;

  margin-left: ${({ isSidebarExpanded }) =>
    isSidebarExpanded === undefined || isSidebarExpanded === null
      ? "0"
      : isSidebarExpanded
      ? "240px"
      : "0"}; /* Login e páginas sem sidebar = 0 */

  transition: margin-left 0.3s ease;
`;


export const HeaderContent = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
`;

export const LogoImage = styled.img`
  height: 30px;
`;
